import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material'
import { useEffect, useState } from 'react'
import { postMessages } from '../../services/claimsService'

interface AddMessageDialogProps {
    setLastUpdate: React.Dispatch<React.SetStateAction<number>>
    close: () => void
    open: boolean
    claimNumber: string
}

export const AddMessageDialog = ({
    setLastUpdate,
    claimNumber,
    open,
    close,
}: AddMessageDialogProps) => {
    const [message, setMessage] = useState('')

    useEffect(() => {
        if (open) {
            setMessage('')
        }
    }, [open])

    const handleSubmitMessage = () => {
        postMessages({ claimNumber, message })
            .then(() => {
                setLastUpdate(new Date().getTime())
                close()
            })
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            .catch((err: Error) => {
                // TO DO
            })
    }

    return (
        <Dialog open={open} onClose={close} maxWidth="lg">
            <DialogTitle>Add Message</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    style={{ width: '600px' }}
                    multiline
                    rows={4}
                    value={message}
                    onChange={(event) => setMessage(event.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button
                    disableElevation={true}
                    variant="contained"
                    style={{ minWidth: '120px' }}
                    onClick={close}
                >
                    Cancel
                </Button>
                <Button
                    disableElevation={true}
                    variant="contained"
                    style={{ minWidth: '120px' }}
                    onClick={handleSubmitMessage}
                    disabled={message.length === 0}
                >
                    Send
                </Button>
            </DialogActions>
        </Dialog>
    )
}
